import React from 'react';
import { useHistory } from 'react-router';
import useTranslation from '../../../../../hooks/use-translation';
import Input from '../InputForm';

const CancelModal = ({handleNoClicked}) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const {t} = useTranslation();

  return (
    <div className="express-interest-modal-container">
          <div className="express-interest-modal-body">
            <p className="express-interest-modal-text">{t("EOI_CANCEL_TEXT")}</p>
            <div className="express-interest-modal-buttons">
              <Input
                type="button"
                addClassInput="express-interest-modal-button-no"
                value={"No"}
                onClick={() => handleNoClicked()} />
              <Input
                type="button"
                addClassInput="express-interest-modal-button-yes"
                value={"Yes"}
                onClick={() => history.push(`/vaccination-details?${urlParams.toString()}`)} />
            </div>
          </div>
        </div>
  )
}

export default CancelModal